/**
 * AchadosCampo — explicações da validação sob um campo da ficha (ADR-030, Req. 1.6).
 *
 * Uma linha por achado, na cor do nível. Como no protótipo, as mensagens `OK` ficam
 * ocultas quando o campo tem mais de 2 mensagens (o que importa é a correção ou o
 * alerta). A observação (ADR-035) é cinza, sem a cor de alerta, e sempre aparece.
 * As mensagens vêm do motor e nunca trazem o valor pessoal completo.
 * ADR-048: o achado que cita uma evidência complementar termina com "ver evidência".
 */

import { AchadoCampo, NivelAchado } from '../services/consulta-types';
import { LinkVerEvidencia } from './LinkVerEvidencia';

export const CLASSE_NIVEL: Readonly<Record<NivelAchado, string>> = {
  OK: 'nivel-ok',
  CORRIGIDO: 'nivel-corr',
  ALERTA: 'nivel-alerta',
  ERRO: 'nivel-erro',
  OBSERVACAO: 'nivel-obs',
};

/** Achados exibidos sob o campo: sem os `OK` quando há mais de 2 mensagens (a observação fica). */
export function achadosVisiveis(achados: readonly AchadoCampo[]): AchadoCampo[] {
  return achados.filter((a) => a.nivel !== 'OK' || achados.length <= 2);
}

export function AchadosCampo({ achados }: { readonly achados: readonly AchadoCampo[] }): JSX.Element | null {
  const visiveis = achadosVisiveis(achados);
  if (visiveis.length === 0) {
    return null;
  }
  return (
    <ul className="achados" aria-label="Explicações da validação">
      {visiveis.map((a, i) => (
        <li key={`${a.regra}-${i}`} className={`achado ${CLASSE_NIVEL[a.nivel]}`} data-nivel={a.nivel}>
          {a.mensagem}
          <LinkVerEvidencia evidenciaId={a.evidenciaId} />
        </li>
      ))}
    </ul>
  );
}
